export default "__VITE_ASSET__BjbOnK9g__"